// extracted by mini-css-extract-plugin
export default {"wrapper":"Contact_wrapper__tUe9l","icon":"Contact_icon__OzUDU","linkedin":"Contact_linkedin__dkD83","github":"Contact_github__gB737","mail":"Contact_mail__beVp3"};